import { ReportObjectType } from "../../../contexts/ReportContext";

interface FieldsAndValuesInterface{
  label:string;
  value:keyof ReportObjectType;
}

export const fieldsAndValues:FieldsAndValuesInterface[] = [
  {
    label: 'Ordem de serviço',
    value: 'id'
  },
  {
    label: 'Status',
    value: 'status'
  },
  {
    label: 'Cliente',
    value: 'customerName'
  },
  {
    label: 'Tempo de produção',
    value: 'productionPace'
  },
  {
    label: 'Operador',
    value: 'producerName'
  },
  {
    label: 'Custo total operador',
    value: 'producerCostTotal'
  },
  {
    label: 'Máquina',
    value: 'machine'
  },
]